/*
 *
 * MMPay Constants
 *
 */

export const SCORE_INIT = 'app/MMPay/SCORE_INIT';
export const SCORE_SUCCESS = 'app/MMPay/SCORE_SUCCESS';
export const SCORE_ERROR = 'app/MMPay/SCORE_ERROR';

export const DAILY_SUMMARY_INIT = 'app/MMPay/DAILY_SUMMARY_INIT';
export const DAILY_SUMMARY_SUCCESS = 'app/MMPay/DAILY_SUMMARY_SUCCESS';
export const DAILY_SUMMARY_ERROR = 'app/MMPay/DAILY_SUMMARY_ERROR';

export const TRANSACTIONS_INIT = 'app/MMPay/TRANSACTIONS_INIT';
export const TRANSACTIONS_SUCCESS = 'app/MMPay/TRANSACTIONS_SUCCESS';
export const TRANSACTIONS_ERROR = 'app/MMPay/TRANSACTIONS_ERROR';

export const SET_MMPAY_RESTAURANT_START_TIME =
  'app/MMPay/SET_MMPAY_RESTAURANT_START_TIME';

export const MMPAY_MAX_RANGE_DAYS = 31;
